<p-sidebar
  [visible]="visible"
  position="right"
  [showCloseIcon]="false"
  [modal]="!dismissible"
  [dismissible]="false"
  [blockScroll]="false"
  [closeOnEscape]="false"
  [transitionOptions]="skipEnterAnimation ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
  [baseZIndex]="1200"
  styleClass="edit-group-sidebar activity-detail-sidebar"
  [style]="{ top: '0', height: '100%' }"
  appendTo="body"
  (onShow)="shown.emit()"
  (onHide)="hidden.emit()"
>
  @if (activityDraft) {
  <div
    class="edit-drawer activity-detail-drawer"
    [class.animate-slide-in]="!skipEnterAnimation"
    [attr.inert]="coveredByDialog ? '' : null"
    [attr.aria-hidden]="coveredByDialog"
    (click)="photoMenuClosed.emit()"
  >
    <div class="edit-drawer-header">
      <button type="button" class="edit-drawer-close" [attr.aria-label]="backButtonLabel" (click)="back.emit()">
        <i class="pi" [ngClass]="backButtonIcon"></i>
      </button>
    </div>

    @if (operationErrorMessage && !coveredByDialog) {
    <div class="edit-save-toast edit-save-toast--error" role="alert">
      <i class="pi pi-exclamation-circle"></i>
      <span>{{ operationErrorMessage }}</span>
      <button
        type="button"
        class="edit-save-toast-close"
        (click)="operationErrorDismissed.emit(); $event.stopPropagation()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    } @else if (discardSuccessVisible) {
    <div class="edit-save-toast edit-save-toast--discard" role="status">
      <i class="pi pi-check"></i>
      <span>{{ 'activityDrawer.changesDiscarded' | translate }}</span>
      <button type="button" class="edit-save-toast-close" (click)="discardSuccessDismissed.emit(); $event.stopPropagation()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    } @else if (saveSuccessVisible) {
    <div class="edit-save-toast">
      <i class="pi pi-check"></i>
      <span>{{ 'activityDrawer.changesSaved' | translate }}</span>
      <button type="button" class="edit-save-toast-close" (click)="saveSuccessDismissed.emit(); $event.stopPropagation()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    }

    <div class="edit-drawer-body" data-groups-drawer-body="activity" (scroll)="bodyScrolled.emit($event)">
      <section class="edit-field-section">
        @if (editingName) {
        <div class="edit-field-label-row">
          <label class="edit-field-label">{{ 'activityDrawer.name' | translate }}</label>
          <button type="button" class="edit-undo-btn" (click)="undoNameRequested.emit(); $event.stopPropagation()">
            <i class="pi pi-replay"></i>
            <span>{{ 'activityDrawer.undo' | translate }}</span>
          </button>
        </div>
        <input
          type="text"
          pInputText
          [(ngModel)]="activityDraft.name"
          (ngModelChange)="draftChanged.emit()"
          class="edit-group-name-input"
          [class.edit-error]="!activityDraft.name.trim()"
        />
        @if (!activityDraft.name.trim()) {
        <small class="edit-error-text">{{ 'activityDrawer.nameRequired' | translate }}</small>
        }
        } @else {
        <div class="edit-drawer-header-content">
          <h2 class="view-group-title">{{ activityDraft.name }}</h2>
          <button type="button" class="view-edit-btn" (click)="editNameRequested.emit()"><i class="pi pi-file-edit"></i> {{ 'activityDrawer.edit' | translate }}</button>
        </div>
        }
        <p class="edit-created-on" [class.edit-created-on--edit]="editingName">{{ 'activityDrawer.createdOn' | translate: { date: createdOn } }}</p>
      </section>

      <section class="edit-field-section">
        <label class="edit-field-label">{{ 'activityDrawer.coverPhoto' | translate }}</label>
        <div class="edit-cover-photo" [class.edit-cover-photo--empty]="!hasCoverPhoto">
          <input
            #coverPhotoInput
            class="edit-photo-file-input"
            type="file"
            accept="image/*"
            (change)="coverPhotoSelected.emit($event)"
          />
          @if (!hasCoverPhoto) {
          <button
            type="button"
            class="edit-cover-photo-empty-btn"
            (click)="openPhotoPicker(coverPhotoInput)"
          >
            <span class="edit-cover-photo-empty-chip" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="14" rx="2"></rect>
                <circle cx="8.5" cy="9.5" r="1.6"></circle>
                <path d="M21 15l-4.5-4.5L7 20"></path>
                <path d="M17 3.5v5M14.5 6h5"></path>
              </svg>
            </span>
            <span class="edit-cover-photo-empty-title">{{ 'activityDrawer.coverPhotoEmptyTitle' | translate }}</span>
            <span class="edit-cover-photo-empty-hint">{{ 'activityDrawer.coverPhotoEmptyHint' | translate }}</span>
          </button>
          } @else {
          <img
            [src]="coverPhotoSrc"
            [alt]="activityDraft.name"
            class="edit-cover-photo-image"
            (error)="coverPhotoError.emit($event)"
          />
          <button type="button" class="edit-cover-photo-btn" (click)="photoMenuToggled.emit($event)">
            <i class="pi pi-file-edit"></i> {{ 'activityDrawer.editPhoto' | translate }}
          </button>
          }
          @if (coverPhotoMenuVisible) {
          <div class="edit-cover-photo-menu" (click)="$event.stopPropagation()">
            <button type="button" class="edit-cover-photo-menu-item" (click)="openPhotoPicker(coverPhotoInput)">
              <i class="pi pi-upload"></i>
              {{ 'activityDrawer.uploadPhoto' | translate }}
            </button>
            <div class="edit-cover-photo-menu-divider" aria-hidden="true"></div>
            <button
              type="button"
              class="edit-cover-photo-menu-item edit-cover-photo-menu-item--danger"
              [disabled]="!hasCoverPhoto"
              (click)="coverPhotoRemoved.emit()"
            >
              <i class="pi pi-trash"></i>
              {{ 'activityDrawer.removePhoto' | translate }}
            </button>
          </div>
          }
        </div>
      </section>

      <section class="edit-field-section">
        <div class="edit-field-label-row">
          <label class="edit-field-label">{{ 'activityDrawer.description' | translate }}</label>
          @if (!editingDescription) {
          <button type="button" class="view-edit-btn" (click)="editDescriptionRequested.emit()"><i class="pi pi-file-edit"></i> {{ 'activityDrawer.edit' | translate }}</button>
          } @else {
          <button
            type="button"
            class="edit-undo-btn"
            (click)="undoDescriptionRequested.emit(); $event.stopPropagation()"
          >
            <i class="pi pi-replay"></i>
            <span>{{ 'activityDrawer.undo' | translate }}</span>
          </button>
          }
        </div>
        @if (editingDescription) {
        <textarea
          pInputTextarea
          [(ngModel)]="activityDraft.description"
          (ngModelChange)="draftChanged.emit()"
          [autoResize]="true"
          rows="4"
          class="edit-description-input"
        ></textarea>
        } @else {
        <div
          class="view-description-box"
          [class.view-description-box--empty]="!hasDescription(activityDraft.description)"
        >
          {{ getDescriptionText(activityDraft.description) }}
        </div>
        }
      </section>

      <section class="edit-field-section">
        <div class="edit-field-label-row">
          <label class="edit-field-label" for="activity-route-url">{{ 'activityDrawer.routeLink' | translate }}</label>
          @if (!editingRouteUrl) {
          <button type="button" class="view-edit-btn" (click)="editRouteUrlRequested.emit()">
            <i class="pi pi-file-edit"></i>
            Edit
          </button>
          } @else {
          <button type="button" class="edit-undo-btn" (click)="undoRouteUrlRequested.emit(); $event.stopPropagation()">
            <i class="pi pi-replay"></i>
            <span>Undo</span>
          </button>
          }
        </div>
        @if (editingRouteUrl) {
        <input
          id="activity-route-url"
          type="url"
          pInputText
          [(ngModel)]="activityDraft.routeUrl"
          (ngModelChange)="draftChanged.emit()"
          placeholder="https://www.strava.com/routes/123456"
          class="edit-route-url-input"
          [class.edit-error]="!isRouteUrlValid(activityDraft.routeUrl)"
          [attr.aria-invalid]="!isRouteUrlValid(activityDraft.routeUrl)"
          [attr.aria-describedby]="!isRouteUrlValid(activityDraft.routeUrl) ? 'activity-route-url-error' : null"
        />
        @if (!isRouteUrlValid(activityDraft.routeUrl)) {
        <small id="activity-route-url-error" class="edit-error-text">
          Enter a valid link starting with http:// or https://
        </small>
        } } @else if (hasRouteUrl(activityDraft.routeUrl)) {
        <a
          class="view-route-link"
          [href]="activityDraft.routeUrl"
          target="_blank"
          rel="noopener noreferrer"
          [title]="activityDraft.routeUrl"
          aria-label="Open route link in a new tab"
        >
          <i class="pi pi-link" aria-hidden="true"></i>
          <span>{{ activityDraft.routeUrl }}</span>
        </a>
        } @else {
        <div class="view-route-empty">
          <i class="pi pi-link" aria-hidden="true"></i>
          <span>{{ 'activityDrawer.noRouteLink' | translate }}</span>
        </div>
        }
      </section>

      <section class="edit-field-section handi-friendly-field">
        <div class="edit-field-label-row">
          <label class="edit-field-label">{{ 'activityDrawer.handiFriendly' | translate }}</label>
        </div>
        <div class="view-route-empty">
          <i class="pi" [class.pi-check-circle]="activityDraft.handiFriendly" [class.pi-minus-circle]="!activityDraft.handiFriendly" aria-hidden="true"></i>
          <span>{{ (activityDraft.handiFriendly ? 'activityDrawer.handiFriendlyYes' : 'activityDrawer.handiFriendlyNo') | translate }}</span>
        </div>
      </section>

      <div class="activity-detail-grid">
        <section class="edit-field-section flex-1">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'activityDrawer.sportType' | translate }}</label>
            @if (editingSport) {
            <button type="button" class="edit-undo-btn" (click)="undoSportRequested.emit(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'activityDrawer.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editSportRequested.emit()"><i class="pi pi-file-edit"></i> {{ 'activityDrawer.edit' | translate }}</button>
            }
          </div>
          @if (editingSport) {
          <div class="edit-sport-dropdown custom-dropdown">
            <p-dropdown
              [options]="sportOptions"
              [ngModel]="selectedSportValue"
              (ngModelChange)="sportChanged.emit($event)"
              optionLabel="label"
              optionValue="value"
              scrollHeight="18rem"
              styleClass="w-full"
              panelStyleClass="groups-sport-dropdown-panel edit-group-sport-dropdown-panel edit-sport-options-panel"
            >
              <ng-template pTemplate="selectedItem" let-selected>
                @if (selected) {
                <div class="edit-sport-selected">
                  <img [src]="getSportIconPath(selected.label)" class="edit-sport-icon" alt="" />
                  <span>{{ selected.label }}</span>
                </div>
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <div
                  class="edit-sport-option"
                  [class.edit-sport-option--selected]="option.value === selectedSportValue"
                >
                  <img [src]="getSportIconPath(option.label)" class="edit-sport-icon" alt="" />
                  <span>{{ option.label }}</span>
                  @if (option.value === selectedSportValue) {
                  <i class="pi pi-check edit-sport-check"></i>
                  }
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          } @else {
          <div class="view-select-box view-sport-box">
            <img [src]="getSportIconPath(activityDraft.sport)" class="edit-sport-icon" alt="" />
            <span>{{ activityDraft.sport }}</span>
          </div>
          }
        </section>

        <section class="edit-field-section flex-1">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'activityDrawer.level' | translate }}</label>
            @if (editingLevel) {
            <button type="button" class="edit-undo-btn" (click)="undoLevelRequested.emit(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'activityDrawer.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editLevelRequested.emit()"><i class="pi pi-file-edit"></i> {{ 'activityDrawer.edit' | translate }}</button>
            }
          </div>
          @if (editingLevel) {
          <div class="edit-sport-dropdown custom-dropdown">
            <p-dropdown
              [options]="levelOptions"
              [ngModel]="activityLevel"
              (ngModelChange)="levelChanged.emit($event)"
              optionLabel="label"
              optionValue="value"
              scrollHeight="22rem"
              styleClass="w-full"
              panelStyleClass="groups-sport-dropdown-panel edit-group-sport-dropdown-panel edit-level-options-panel"
            >
              <ng-template pTemplate="selectedItem" let-selected>
                @if (selected) {
                <div class="edit-level-option">
                  <img src="assets/icons/level-ribbon.svg" class="edit-level-icon" alt="" />
                  <span>{{ selected.label }}</span>
                </div>
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <div
                  class="edit-level-option"
                  [class.edit-level-option--all]="option.value === 'all'"
                  [class.edit-level-option--selected]="option.value === activityLevel"
                >
                  <img src="assets/icons/level-ribbon.svg" class="edit-level-icon" alt="" />
                  <span>{{ option.label }}</span>
                  @if (option.value === activityLevel) {
                  <i class="pi pi-check edit-level-check"></i>
                  }
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          } @else {
          <div class="view-select-box view-sport-box activity-level-box">
            <img src="assets/icons/level-ribbon.svg" class="edit-level-icon" alt="" />
            <span>{{ activityLevel === 'all' ? 'All levels' : 'Level ' + activityLevel }}</span>
          </div>
          }
        </section>
      </div>

      <div
        class="edit-disabled-zone activity-disabled-zone"
        [class.edit-disabled-zone--active]="editActionMode"
        [attr.inert]="editActionMode ? '' : null"
        [attr.aria-disabled]="editActionMode"
      >
        <section class="edit-field-section">
          <label class="edit-field-label activity-muted-label">{{ 'activityDrawer.dateTime' | translate }}</label>
          <div class="activity-date-card">
            <div class="activity-date-card-title">
              <i class="pi pi-calendar"></i><span>{{ scheduleLabel }}</span>
            </div>
            <div class="activity-date-card-meta">
              <div class="activity-date-meta-item"><span>{{ 'activityDrawer.startDate' | translate }}</span><strong>{{ startDate }}</strong></div>
              <i class="pi pi-arrow-right activity-date-arrow"></i>
              <div class="activity-date-meta-item"><span>{{ 'activityDrawer.endDate' | translate }}</span><strong>{{ endDate }}</strong></div>
              <div class="activity-date-meta-item"><span>{{ 'activityDrawer.duration' | translate }}</span><strong>{{ durationLabel }}</strong></div>
            </div>
          </div>
        </section>

        <section class="edit-field-section">
          <label class="edit-field-label activity-muted-label">{{ 'activityDrawer.visibility' | translate }}</label>
          <div class="activity-visibility-card"><i class="pi pi-users"></i><span>{{ getVisibilityText(activityDraft) }}</span></div>
        </section>

        <section class="edit-readonly-section">
          <h4 class="edit-list-title">{{ 'activityDrawer.organizer' | translate }} (1)</h4>
          <div class="edit-list">
            <div class="edit-list-item">
              @if (getOrganizerAvatarUrl(activityDraft)) {
              <img
                [src]="getOrganizerAvatarUrl(activityDraft)"
                [alt]="activityDraft.host"
                class="edit-list-avatar edit-list-avatar-image"
                (error)="onOrganizerAvatarError(activityDraft)"
              />
              } @else {
              <div class="edit-list-avatar">{{ getInitials(activityDraft.host) }}</div>
              }
              <div class="edit-list-content">
                <span class="edit-list-primary">{{ activityDraft.host }}</span>
                <span class="edit-list-secondary edit-list-email">{{ hostEmail }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="edit-readonly-section">
          <h4 class="edit-list-title">{{ 'activityDrawer.participants' | translate }} ({{ participantTotal }})</h4>
          <div class="edit-list">
            @for (participant of participants; track participant.email) {
            <div class="edit-list-item">
              @if (getParticipantAvatarUrl(participant)) {
              <img
                [src]="getParticipantAvatarUrl(participant)"
                [alt]="participant.name"
                class="edit-list-avatar edit-list-avatar-image"
                (error)="onParticipantAvatarError(participant)"
              />
              } @else {
              <div class="edit-list-avatar">{{ getInitials(participant.name) }}</div>
              }
              <div class="edit-list-content">
                <span class="edit-list-primary">{{ participant.name }}</span>
                <span class="edit-list-secondary edit-list-email">{{ participant.email }}</span>
              </div>
            </div>
            }
            @empty {
            <div class="edit-list-empty">{{ 'activityDrawer.noParticipants' | translate }}</div>
            }
          </div>
          @if (canToggleParticipants) {
          <button
            type="button"
            class="edit-list-more-btn"
            [disabled]="participantsLoading"
            (click)="toggleParticipants.emit()"
          >
            @if (participantsLoading) { Loading... } @else if (participantsExpanded) { Show less
            <i class="pi pi-chevron-up"></i> } @else { + {{ participantsMoreCount }} more
            <i class="pi pi-chevron-down"></i>
            }
          </button>
          }
        </section>
      </div>
    </div>

    <div class="edit-drawer-footer">
      <button type="button" class="edit-delete-group-btn" (click)="deleteRequested.emit()">
        @if (isCancelIcon(activityDraft)) {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <path d="M16 8l-8 8M8 8l8 8"></path>
        </svg>
        } @else {
        <i class="pi pi-trash"></i>
        }
        {{ getDeleteButtonLabel(activityDraft) }}
      </button>
      @if (editActionMode) {
      <div class="edit-footer-actions">
        <button type="button" class="edit-discard-btn" (click)="discardRequested.emit()">{{ 'activityDrawer.discardAll' | translate }}</button>
        <button type="button" class="edit-save-btn" [disabled]="!canSave" (click)="saveRequested.emit()">
          <i class="pi pi-save"></i>
          {{ 'activityDrawer.saveAll' | translate }}
        </button>
      </div>
      } @else {
      <button type="button" class="edit-close-btn" (click)="closed.emit()">{{ 'activityDrawer.close' | translate }}</button>
      }
    </div>
  </div>
  }
</p-sidebar>
